export default __webpack_public_path__ + "static/illu_materialien-1e0df0d8407ddcea2f2c4ebd224a3a1a.svg";